export type NumericInput = number | string | boolean | object | (() => void) | null | undefined;

export default function isNumeric(value: NumericInput): boolean {
  return (
    typeof value === 'number' || (value != null && value !== '' && !Number.isNaN(Number.parseFloat(String(value))))
  );
}
